import React, { Component } from "react";
import ReactPaginate from "react-paginate";
import { Table, Card, Row, Col, Form, Image } from "react-bootstrap";
import ProductReturnsView from "./ProductReturnsView";
var dateFormat = require("dateformat");

class ProductReturns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ProductReturnsShow: false,
      page: 0,
      perPage: 10,
      Spage: 0,
      perPageS: 10,
      searchProductReturns: "",
      searchShow: false,
      perPagef: 10,
      FltrPage: 0,
      filterValue: "All",
      FilterTable: false,
    };
  }

  componentDidMount() {
    this.props.ProductReturn();
  }

  handleProductReturnsView = (item) => {
    this.setState({
      ProductReturnsShow: true,
      ProductReturnsDtls: item,
    });
    this.props.ProductReturnview(item);
  };

  handleCloseProductReturnsView = () => {
    this.setState({ ProductReturnsShow: false });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.ProductReturnsSlectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };
  resetPage = () => {
    this.setState({ page: 0 });
  };

  handlePageSearchClick = (e) => {
    const selectedSearchPage = e.selected;
    this.setState({ Spage: selectedSearchPage });
    let Sdata = {
      Spage: selectedSearchPage + 1,
      ProductReturns: this.state.searchProductReturns,
    };
    this.props.ProductReturnsSearchSelectedPage(Sdata);
  };

  SearchOnChange = (event) => {
    let ProductReturns = event.target.value;
    this.setState({
      searchShow: true,
      FilterTable: false,
      filterValue: "All",
      searchProductReturns: ProductReturns,
    });
    let Sdatas = {
      Spage: this.state.Spage + 1,
      ProductReturns: ProductReturns,
    };
    this.props.ProductReturnsSearch(Sdatas);
  };

  handleChange = (event) => {
    this.setState({
      FltrPage: 0,
      filterValue: event.target.value,
      searchProductReturns: "",
    });

    if (event.target.value == "All") {
      this.setState({
        FilterTable: false,
        searchShow: false,
      });
    } else {
      this.props.FliterSearchProductUser({
        page: 1,
        value: event.target.value,
      });
      this.setState({ FilterTable: true });
    }
  };

  handlePageFltrClick = (e) => {
    const selectedFltrPage = e.selected;
    this.setState({ FltrPage: selectedFltrPage });
    this.props.fltrProductUserPagetn({
      page: selectedFltrPage + 1,
      value: this.state.filterValue,
    });
  };

  render() {
    let p = this.state.page + 1;
    const count =
      this.props.ProductReturnlsCount && this.props.ProductReturnlsCount;
    let ProductReturnsPageCount = Math.ceil(count / this.state.perPage);

    let p2 = this.state.Spage + 1;
    const SearchCount =
      this.props.ProductReturnSearchCount &&
      this.props.ProductReturnSearchCount;
    const SearchPageCount = Math.ceil(SearchCount / this.state.perPageS);

    let p3 = this.state.FltrPage + 1;
    const FltrCount =
      this.props.productuserFilterCount && this.props.productuserFilterCount;
    const fltrPageCount = Math.ceil(FltrCount / this.state.perPagef);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={12} md={3} lg={3}>
                <h3>Product Returns</h3>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select
                    value={this.state.filterValue}
                    onChange={this.handleChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    <option value="created">Created</option>
                    <option value="accepted">Accepted</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                    <input
                      type="text"
                      placeholder="Search by Order Id/Name"
                      value={this.state.searchProductReturns}
                      onChange={this.SearchOnChange}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {/* {count === undefined && SearchCount === undefined ? (
                      0
                    ) : (
                      <span>
                        {!this.state.searchShow && count}
                        {this.state.searchShow && SearchCount}
                      </span>
                    )} */}
                    {count === undefined &&
                    SearchCount === undefined &&
                    FltrCount === undefined ? (
                      0
                    ) : (
                      <span>
                        {!this.state.searchShow &&
                          !this.state.FilterTable &&
                          count}
                        {!this.state.FilterTable &&
                          this.state.searchShow &&
                          SearchCount}
                        {this.state.FilterTable && FltrCount}
                      </span>
                    )}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              {!this.state.searchShow && !this.state.FilterTable && (
                <Table responsive bordered striped className="cmnMainTable">
                  <thead>
                    <tr className="cmnMainTableHd">
                      <th>SL NO</th>
                      <th>ORDER ID</th>
                      <th style={{ width: "200px" }}>CHEMIST NAME</th>
                      <th>DISTRIBUTOR NAME </th>

                      <th>CREATED DATE & TIME</th>
                      <th>STATUS</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.ProductReturnDtlsList &&
                      this.props.ProductReturnDtlsList.map((item, i) => (
                        <tr key={i}>
                          <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                          <td className="cmn_Cap">
                            {item !== null && item.orderNo}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.chmstDtls
                              ? item.chmstDtls.name
                              : null}
                            {/* {item.orderFrom !== null &&
                              (item.orderFrom.name !== undefined
                                ? item.orderFrom.name
                                : "") +
                                " " +
                                (item.orderFrom.lName !== undefined
                                  ? item.orderFrom.lName
                                  : "")} */}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.dstbtrDtls
                              ? item.dstbtrDtls.name
                              : null}
                            {/* {item.orderTo !== null &&
                              (item.orderTo.name !== undefined
                                ? item.orderTo.name
                                : "") +
                                " " +
                                (item.orderTo.lName !== undefined
                                  ? item.orderTo.lName
                                  : "")} */}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.createdAt
                              ? dateFormat(
                                  item.createdAt,
                                  "dd-mmm-yyyy, h:MM TT"
                                )
                              : null}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.status}
                          </td>

                          <td className="cmnViewIcon">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  this.handleProductReturnsView({ item: item })
                                }
                              ></i>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              )}

              <ProductReturnsView
                show={this.state.ProductReturnsShow}
                handleClose={this.handleCloseProductReturnsView}
                ProductReturnsDtls={this.state.ProductReturnsDtls}
                ProductReturnls={this.props.ProductReturnls}
                ProductReturnDtlsCount={this.props.ProductReturnDtlsCount}
              />

              {this.state.searchShow && !this.state.FilterTable && (
                <Table responsive bordered striped className="cmnMainTable">
                  <thead>
                    <tr className="cmnMainTableHd">
                      <th>SL NO</th>
                      <th>ORDER ID</th>
                      <th style={{ width: "200px" }}>CHEMIST NAME</th>
                      <th>DISTRIBUTOR NAME </th>

                      <th>CREATED DATE</th>
                      <th>STATUS</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.ProductReturnSearchList &&
                      this.props.ProductReturnSearchList.map((item, i) => (
                        <tr key={i}>
                          <td className="cmn_Cap">{10 * (p2 - 1) + i + 1}</td>
                          <td className="cmn_Cap">
                            {item !== null && item.orderNo}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.chmstDtls
                              ? item.chmstDtls.name
                              : null}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.dstbtrDtls
                              ? item.dstbtrDtls.name
                              : null}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.createdAt
                              ? dateFormat(
                                  item.createdAt,
                                  "dd-mmm-yyyy, h:MM TT"
                                )
                              : null}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.status}
                          </td>

                          <td className="cmnViewIcon">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  this.handleProductReturnsView({ item: item })
                                }
                              ></i>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              )}

              {this.state.FilterTable && (
                <Table responsive bordered striped className="cmnMainTable">
                  <thead>
                    <tr className="cmnMainTableHd">
                      <th>SL NO</th>
                      <th>ORDER ID</th>
                      <th style={{ width: "200px" }}>CHEMIST NAME</th>
                      <th>DISTRIBUTOR NAME </th>

                      <th>CREATED DATE</th>
                      <th>STATUS</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.productuserFilterList &&
                      this.props.productuserFilterList.map((item, i) => (
                        <tr key={i}>
                          <td className="cmn_Cap">{10 * (p3 - 1) + i + 1}</td>
                          <td className="cmn_Cap">
                            {item !== null && item.orderNo}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.chmstDtls
                              ? item.chmstDtls.name
                              : null}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.dstbtrDtls
                              ? item.dstbtrDtls.name
                              : null}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.createdAt
                              ? dateFormat(
                                  item.createdAt,
                                  "dd-mmm-yyyy, h:MM TT"
                                )
                              : null}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.status}
                          </td>

                          <td className="cmnViewIcon">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  this.handleProductReturnsView({ item: item })
                                }
                              ></i>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              )}

              {!this.state.searchShow &&
                !this.state.FilterTable &&
                (this.props.ProductReturnDtlsList === undefined ||
                  (this.props.ProductReturnDtlsList &&
                    this.props.ProductReturnDtlsList.length === 0)) && (
                  <div>
                    <div className="noDataImgDiv">
                      <Image
                        className="noDataImg"
                        src={require("../../assets/img/nodata4.png")}
                      />
                    </div>
                    <div className="noDataTextDiv">No Returns Found</div>
                  </div>
                )}

              {this.state.searchShow &&
                !this.state.FilterTable &&
                (this.props.ProductReturnSearchList === undefined ||
                  (this.props.ProductReturnSearchList &&
                    this.props.ProductReturnSearchList.length === 0)) && (
                  <div>
                    <div className="noDataImgDiv">
                      <Image
                        className="noDataImg"
                        src={require("../../assets/img/nodata4.png")}
                      />
                    </div>
                    <div className="noDataTextDiv">No Returns Found</div>
                  </div>
                )}

              {this.state.FilterTable &&
                (this.props.productuserFilterList === undefined ||
                  (this.props.productuserFilterList &&
                    this.props.productuserFilterList.length === 0)) && (
                  <div>
                    <div className="noDataImgDiv">
                      <Image
                        className="noDataImg"
                        src={require("../../assets/img/nodata4.png")}
                      />
                    </div>
                    <div className="noDataTextDiv">No Profiles Found</div>
                  </div>
                )}
            </div>
          </Card.Body>
          {!this.state.searchShow &&
          !this.state.FilterTable &&
          ProductReturnsPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={ProductReturnsPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}

          {!this.state.FilterTable &&
          this.state.searchShow &&
          SearchPageCount &&
          SearchPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.Spage}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={SearchPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageSearchClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
          {this.state.FilterTable && fltrPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.FltrPage}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={fltrPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageFltrClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}
export default ProductReturns;
